import { Injectable, signal } from '@angular/core';

export interface MessageBoxData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Injectable({ providedIn: 'root' })
export class MessageBoxService {
  private _isOpen = signal<boolean>(false);
  private _data = signal<MessageBoxData | null>(null);
  private _result = signal<boolean | null>(null);
  private _resolvePromise: ((value: boolean | PromiseLike<boolean>) => void) | null = null;

  isOpen = this._isOpen.asReadonly();
  data = this._data.asReadonly();
  result = this._result.asReadonly();

  open(data: MessageBoxData): Promise<boolean> {
    this._data.set(data);
    this._isOpen.set(true);
    this._result.set(null);

    return new Promise((resolve) => {
      this._resolvePromise = resolve;
    });
  }

  close(result: boolean): void {
    this._result.set(result);
    this._isOpen.set(false);
    this._data.set(null);

    if (this._resolvePromise) {
      this._resolvePromise(result);
      this._resolvePromise = null;
    }
  }
}